import React from 'react';

export const formatRisk = (riskLvl: number): React.ReactNode => {
  if (riskLvl <= 1) {
    return <span className="risk-level font-bold text-green-600">Safest</span>;
  } else if (riskLvl === 2) {
    return <span className="risk-level font-bold text-green-400">Low Risk</span>;
  } else if (riskLvl === 3) {
    return <span className="risk-level font-bold text-yellow-500">Some Risk</span>;
  } else if (riskLvl === 4) {
    return <span className="risk-level font-bold text-yellow-600">More Risk</span>;
  } else {
    return <span className="risk-level font-bold text-red-600">High Risk</span>;
  }
};

export const handleSorting = (a: any, b: any, dataItemKey: string) => {
  const getValue = (data: Record<string, any>) => {
    const value = data?.data?.[dataItemKey]?.value;
    return Array.isArray(value) ? value[0] : value;
  };

  const [aValue, bValue] = [getValue(a), getValue(b)];

  return aValue && bValue ? aValue - bValue : 0;
};
